export function fmtTime(sec) {
  sec = Math.max(0, Math.floor(sec));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
export function fmtMinutes(sec) {
  return `${Math.floor((sec || 0) / 60)} min`;
}
export function fmtEuros(cents) {
  return `${((cents || 0) / 100).toFixed(2).replace(".", ",")} €`;
}
export function fmtRate(rate) {
  return `${Number(rate || 0).toFixed(2).replace(".", ",")} €/min`;
}
export function fmtDate(iso) {
  try { return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
}
